module.exports = __webpack_public_path__ + "static/media/foreign-trade.44aa2cbf.svg";